import { useQuery } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { AuditLogsRequest, AuditLogsResponse } from '@/types/settings-api';

/**
 * Audit log paginated query for the Logs tab (PROD-766).
 *
 * `POST /api/Organization/GetAuditLogHistoryList`
 *
 * Flutter source: `settings_data_source_impl.dart:1260-1273` (`fetchAuditLogsList`).
 * Hits `organizationAPI(OrganizationService.Organization)` (`/api/Organization`)
 * with `/GetAuditLogHistoryList` suffix — NOT `/api/AuditLog`. The original
 * React URL was a REST guess that would 404 in dev (not visible until an
 * OrgAdmin user loads the Logs tab — the dev Practitioner doesn't have access).
 *
 * Body is `AuditLogsRequest` with pagination + filters (date range, action,
 * user, IP, etc). The cache key includes the full request so any filter
 * change re-fetches.
 */
export function useAuditLogs(req: AuditLogsRequest | null) {
  return useQuery({
    queryKey: ['settings', 'audit-logs', req],
    queryFn: ({ signal }) => {
      if (!req) throw new Error('useAuditLogs called without request');
      return post<AuditLogsResponse>(
        '/api/Organization/GetAuditLogHistoryList',
        req,
        { signal },
      );
    },
    enabled: !!req?.organizationId,
  });
}
